import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { observable, of, Observable } from "rxjs";
import { map, mergeMap, catchError } from "rxjs/operators";
import { ClientService } from '@core/services/client/client.service';
import { ClientfileschedulesService } from '@core/services/client/clientfileschedules.services';
import * as fileScheduleActions from "../fileschedule_state/fileschedule.actions";
import { Client,ClientFileScheduleAndContractInfoModel } from '@core/services/client/client.model';


@Injectable()
export class FileScheduleEffect{
    constructor(
        private actions$: Actions,
        private clientfileschedulesService: ClientfileschedulesService
    ){}

        /* -Load  one FileSchedule- */

        @Effect()
        loadFileSchedule$: Observable<Action> = this.actions$.pipe(
          ofType<fileScheduleActions.LOADFILESCHEDULE>(
            fileScheduleActions.ClientFileScheduleActionTypes.LOAD_FILESCHEDULE
          ),
          mergeMap((action: fileScheduleActions.LOADFILESCHEDULE) =>
            this.clientfileschedulesService.searchFileScheduleByClientId(action.payload).pipe(
              map(
                (fileschedule: ClientFileScheduleAndContractInfoModel) =>
                  new fileScheduleActions.LOADFILESCHEDULESUCCESS(fileschedule)
              ),
              catchError(err => of(new fileScheduleActions.LOADFILESCHEDULEFAIL(err)))
            )
          )
        );


          /* -create File Schedule- */

          @Effect()
          createFileSchedule$: Observable<Action> = this.actions$.pipe(
           ofType<fileScheduleActions.CREATEFILESCHEDULE>(
            fileScheduleActions.ClientFileScheduleActionTypes.CREATE_FILESCHEDULE
           ),
           map((action: fileScheduleActions.CREATEFILESCHEDULE) => action.payload),
           mergeMap((fileschedule: ClientFileScheduleAndContractInfoModel) =>
                  this.clientfileschedulesService.createFileSchedule(fileschedule).pipe(
            map(
               (fileschedule: ClientFileScheduleAndContractInfoModel) =>
                new fileScheduleActions.CREATEFILESCHEDULESUCCESS(fileschedule)
             ),
              catchError(err => of(new fileScheduleActions.CREATEFILESCHEDULEFAIL(err)))
        )
      )
    );

     /* -update FileSchedule- */

    @Effect()
    updateFileSchedule$: Observable<Action> = this.actions$.pipe(
      ofType<fileScheduleActions.UPDATEFILESCHEDULE>(
        fileScheduleActions.ClientFileScheduleActionTypes.UPDATE_FILESCHEDULE
      ),
      map((action: fileScheduleActions.UPDATEFILESCHEDULE) => action.payload),
      mergeMap((fileschedule: ClientFileScheduleAndContractInfoModel) =>
        this.clientfileschedulesService.updateFileSchedule(fileschedule).pipe(
          map(
            (updateFileSchedule: ClientFileScheduleAndContractInfoModel) =>
              new fileScheduleActions.UPDATEFILESCHEDULESUCCESS({
                id: updateFileSchedule.id,
                changes: updateFileSchedule
              })
          ),
          catchError(err => of(new fileScheduleActions.UPDATEFILESCHEDULEFAIL(err)))
        )
      )
    );

      


}
